import clsx from "clsx";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

import { HeroPortraitProps } from "./hero-portrait";

interface HeroPortraitCardInnerProps
  extends Pick<HeroPortraitProps, "contact">,
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const HeroPortraitCardInner: FC<PropsWithChildren<HeroPortraitCardInnerProps>> = ({
  contact,
  className,
}) => (
  <div className={clsx(["rounded-3xl overflow-hidden flex-col w-full max-w-md", className])}>
    {contact?.image?.gatsbyImageData && (
      <GatsbyImage
        image={contact.image.gatsbyImageData}
        alt={contact?.titleLine1 ?? ""}
        objectFit="cover"
        className="aspect-square"
      />
    )}
    {(contact?.titleLine1 || contact?.titleLine2 || contact?.subtitle) && (
      <div className="flex flex-col gap-3 text-light flex-none p-5 lg:px-8 ,d:py-6 bg-primary w-full">
        {(contact?.titleLine1 || contact?.titleLine2) && (
          <div className="text-2xl lg:text-3xl">
            {contact?.titleLine1} {contact?.titleLine2}
          </div>
        )}
        {contact?.subtitle && (
          <div className="text-base font-light leading-snug">{contact?.subtitle}</div>
        )}
      </div>
    )}
  </div>
);
